import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.LandingSellOnlineSection
  }, [_c('span', {
    class: [_vm.$style.gradientCircle, _vm.$style.gradientCircle2]
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.inner
  }, [_c('div', {
    class: _vm.$style.top
  }, [_c('div', {
    class: [_vm.$style.title, _vm.$style.gradientText],
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.text,
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.$style.bottom
  }, [_c('div', {
    class: _vm.$style.left
  }, [_c('div', {
    class: _vm.$style.items
  }, _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.item
    }, [_c('div', {
      class: _vm.$style.itemTitle
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]), _vm._v(" "), _c('div', {
      class: _vm.$style.itemText
    }, [_vm._v("\n                " + _vm._s(item.description) + "\n              ")])]);
  }), 0), _vm._v(" "), _c('div', {
    class: _vm.$style.buttonWrapper
  }, [_c(_setup.SButton, {
    class: _vm.$style.button,
    attrs: {
      "n-link": "",
      "href": "/account/agents/registration",
      "rounded": "",
      "theme": "primary",
      "size": "x-large"
    }
  }, [_vm._v("\n              Зарегистрироваться\n            ")])], 1)]), _vm._v(" "), _c('div', {
    class: _vm.$style.img
  }, [_c(_setup.ResponsivePicture, {
    attrs: {
      "src-mobile": _setup.onlineImg,
      "src-desktop": _setup.onlineImg2x
    }
  })], 1)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };